import {Fragment, useState} from 'react'
import { FormattedMessage } from 'react-intl'
import { Menu, Transition, Dialog } from '@headlessui/react'
import { ArrowLeftOnRectangleIcon, LanguageIcon, BookmarkSquareIcon, QuestionMarkCircleIcon, XMarkIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { logout } from '../../actions'
import LanguageSelectModal from './LanguageSelectModal'
import SignInModal from './SignInModal'

const HeaderMetedBase = (props) => {
    const { dispatch, viewer} = props;
    const {logged_in, userName, firstName, lastName, email} = props.user.metadata;
    const {user_initialized} = viewer;
      
    let ready = user_initialized;
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [loginModalOpen, toggleLoginModal] = useState(false);
    const [languageModalOpen, toggleLanguageModal] = useState(false);
    
    let userInitials = firstName.charAt(0) + lastName.charAt(0);

    //Spanish MetEd adjustments
    //let metedHomeRoute = localeExtension === '_es' ? '/index_es.php' : '/';


    const handleloginModalToggle = () => {
      toggleLoginModal(!loginModalOpen);
    }

    const handleLanguageModalToggle = () => {
      toggleLanguageModal(!languageModalOpen);
    }

    const handleLogout = () => {
      dispatch(logout());
    }

        
    const classNames = (...classes) => {
        return classes.filter(Boolean).join(' ')
    }
    
    return (
        <header id="et-header" className="bg-gray-800 px-4 py-2 shadow-md shadow-slate-900/5 transition duration-500 dark:shadow-none sm:px-6 lg:px-8 dark:bg-slate-900/95 dark:backdrop-blur dark:[@supports(backdrop-filter:blur(0))]:bg-slate-900/75 text-white">
            {/* TOPNAV mobile */}
            <div className="flex justify-between lg:hidden">
              {/* left col */}
              <div className="mr-6">
               
                <button type="button" className="relative pt-1" aria-label="Open navigation" onClick={() => setSidebarOpen(!sidebarOpen)}>
                  <svg aria-hidden="true" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" className="h-6 w-6 stroke-slate-500"><path d="M4 7h16M4 12h16M4 17h16"></path></svg>
                </button>
               
              </div>
              {/* center col */}
              <div className="">
                <div className="flex flex-shrink-0 items-center">
                  <Link to='/'>
                    <img
                    className="h-8 w-auto lg:block"
                    src={process.env.PUBLIC_URL + '/static/img/meted_logo.png'}
                    alt="COMET MetEd - Education and Training"
                    />
                  </Link>
                </div>
              </div>
              {/* right col */}
              <div className="mx-4">
                {/* Notifications?? */}
              </div>
            </div>


            {/* DESKTOP TOPNAV */}
            <div className="lg:flex justify-between hidden">
            {/* left col */}
            <div className="">
                <div className="flex flex-shrink-0 items-center">
                  <Link to='/'>
                    <img
                    className="h-8 w-auto lg:block"
                    src={process.env.PUBLIC_URL + '/static/img/meted_logo.png'}
                    alt="COMET MetEd - Education and Training"
                    />
                  </Link>
                </div>
              </div>
            {/* right col */}
            <div className="relative flex basis-0 justify-end gap-6 sm:gap-8 md:flex-grow">
                {/* header ready */}
                
                <>
                {logged_in
                ?
                <Menu as="div" className="relative ml-3">
                  <div>
                    <Menu.Button className="flex bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 rounded-full">
                      <span className="sr-only">Open user menu</span>
                      <span
                        className="py-2 px-2 bg-blue-600 text-white rounded-full w-9 h-9"
                      >
                      {userInitials}
                      </span>
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items className="absolute right-0 z-10 mt-2 w-48 origin-top-right bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none  divide-y divide-gray-100">
                    <div className="px-4 py-3 text-gray-900">
                      <p className="text-sm"><FormattedMessage id='app.signed_in_as' defaultMessage="Signed in as" /></p>
                      <p className="truncate text-sm font-medium">{email}</p>
                    </div>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={classNames(active ? "bg-gray-200" : "", "inline-block min-w-full text-left px-4 py-2 text-sm text-gray-700")}
                            onClick={handleLanguageModalToggle}
                          >
                          <LanguageIcon className="h-5 w-5 inline" /> <FormattedMessage id="language.label" defaultMessage="Language" />
                          </button>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <Link to="/help"
                            className={classNames(active ? "bg-gray-200" : "", "inline-block min-w-full text-left px-4 py-2 text-sm text-gray-700")}
                          >
                          <QuestionMarkCircleIcon className="h-5 w-5 inline" /> <FormattedMessage id="help.label" defaultMessage="Help" />
                          </Link>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <button
                            className={classNames(active ? "bg-gray-200" : "", "inline-block min-w-full text-left px-4 py-2 text-sm text-gray-700")}
                            onClick={handleLogout}
                          >
                          <ArrowLeftOnRectangleIcon className="h-5 w-5 inline" /> <FormattedMessage id="userMenu.logout" defaultMessage="Logout" /> 
                          </button>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
                :
                <ul className="flex items-center gap-x-2 text-sm transition-all duration-150 ease-in-out">
                  <li>
                    <Link to="https://learn.meted.ucar.edu/#/login"
                    className="flex items-center focus:outline-none bg-[#1A658F] px-4 py-2 text-sm font-medium text-white shadow-lg hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md">
                      <FormattedMessage id="login.sign_in" defaultMessage="Login" />
                    </Link>
                  </li>
                  <li>
                    <button className="flex items-center focus:outline-none bg-[#1A658F] px-4 py-2 text-sm font-medium text-white shadow-lg hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md"
                        onClick={()=>{handleLanguageModalToggle()}}>
                        <LanguageIcon className="mr-2 flex-shrink-0 h-5 w-5" /> <FormattedMessage id="language.label" defaultMessage="Language" />
                    </button>
                  </li>
                  <li>
                    <Link to="/help" className="flex items-center focus:outline-none bg-[#1A658F] px-4 py-2 text-sm font-medium text-white shadow-lg hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md">
                      <QuestionMarkCircleIcon className="mr-2 flex-shrink-0 h-5 w-5" /> <FormattedMessage id="help.label" defaultMessage="Help" />
                    </Link>
                  </li>
                  
                  {/*<li><LanguageSelectDropdown /></li>*/}
                </ul>
                }
                </>
                
                

            </div>
            </div>

          <Transition.Root show={sidebarOpen} as={Fragment}>
          <Dialog as="div" className="relative z-40 lg:hidden" onClose={setSidebarOpen}>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>


            <div className="fixed inset-0 z-20 flex">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex w-full max-w-xs flex-1 flex-col bg-white pt-5 pb-4">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 mr-2 pt-6">
                      <button
                        type="button"
                        className="ml-1 flex h-8 w-8 ring-2 ring-gray-600 items-center justify-center focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={() => setSidebarOpen(false)}
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XMarkIcon className="h-6 w-6 text-gray-600" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="mt-2 h-0 flex-1 overflow-y-auto ">
                  <div className="mx-auto flex items-center px-2">
                    <img className="w-24" src={process.env.PUBLIC_URL +  '/static/img/metedlogo-black-med.png'} alt="MetEd" />                    
                  </div>
                  <hr className="my-4 shadow" />

                    {/* CATALOG navigation menu [mobile] */}
                    <nav className="space-y-1 px-2 mt-6">
                      <a href="https://learn.meted.ucar.edu/#/login" className={"group py-2 px-2 flex items-center text-base font-medium hover:bg-gray-200 hover:text-gray-900"}>
                        <ArrowLeftOnRectangleIcon className="mr-4 flex-shrink-0 h-6 w-6" /> <FormattedMessage id="login.sign_in" defaultMessage="Login" />
                      </a>
                      <a href="https://learn.meted.ucar.edu/#/catalog" className={"group py-2 px-2 flex items-center text-base font-medium hover:bg-gray-200 hover:text-gray-900"}>
                        <BookmarkSquareIcon className="mr-4 flex-shrink-0 h-6 w-6" /> <FormattedMessage id="catalog.label" defaultMessage="Catalog" />
                      </a>
                      <Link to="/help" className="group py-2 px-2 flex items-center text-base font-medium hover:bg-gray-200 hover:text-gray-900">
                        <QuestionMarkCircleIcon className="mr-4 flex-shrink-0 h-6 w-6" /> <FormattedMessage id="help.label" defaultMessage="Help" />
                      </Link>
                    </nav>

                    

                    <button tabIndex={0} className="border border-gray-400 m-4 flex items-center focus:outline-none bg-[#1A658F] px-6 py-3 text-base font-medium text-white shadow-lg hover:bg-cyan-600 focus:ring-2 focus:ring-cyan-600 focus:ring-offset-2 rounded-md"
                        onClick={()=>{handleLanguageModalToggle()}}>
                        <LanguageIcon className="mr-4 flex-shrink-0 h-6 w-6" /> <FormattedMessage id="language.label" defaultMessage="Language" />
                    </button>
                  </div>

                  {/* User menu at bottom of sidebar */}
                  <div className="flex flex-shrink-0 border-t border-gray-200 p-4">
                    {logged_in
                    ?
                    <div className="flex items-center">
                        <div>
                          <Link className="flex bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800 rounded-full"
                            to="."
                          >
                            <span className="sr-only">Your Account</span>
                            <span
                              className="py-2 px-2 bg-blue-600 text-white rounded-full w-9 h-9"
                              title={`View Profile: ${userName}`}
                            >
                            {userInitials}
                            </span>
                          </Link>
                        </div>
                        <div className="ml-3">
                          <p className="text-left text-sm font-medium text-gray-700 group-hover:text-gray-900">{firstName} {lastName}</p>
                          <p className="text-left text-xs font-medium text-gray-500 group-hover:text-gray-700">{email}</p>
                        </div>
                    </div>
                    : 
                    <nav className="space-y-2 px-2 list-none flex-1">
                      {/*<li>
                        <Link to="/register"
                        className="ring-1 ring-blue-600 bg-blue-600 m-0 py-2 px-auto text-center text-base font-semibold leading-7 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 min-w-full block">
                          Join for free
                        </Link>
                      </li>
                      <li>
                        <button className="ring-1 ring-blue-600 bg-blue-600 m-0 py-2 px-auto text-center text-base font-semibold leading-7 text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600 min-w-full block"
                          type='button'
                          onClick={handleMobileRedirectSignIn}
                        >Sign In
                        </button>
                      </li>*/}
                    </nav>
                    }
                  </div>
                  {logged_in
                  ?
                  <div className="list-none grid text-center -mb-4 text-sm text-gray-700 mt-2">
                      {/*<Link 
                      to="/settings" 
                      className="bg-gray-50 hover:bg-gray-200 py-4 px-4 border border-gray-200">
                        <CogIcon className="w-5 h-5 inline" /> <FormattedMessage id="userMenu.settings" defaultMessage="Settings" />
                      </Link>*/}
                      <button className="bg-gray-50 hover:bg-gray-200 py-4 px-4 border border-gray-200"
                        onClick={handleLogout}>
                        <ArrowLeftOnRectangleIcon className="w-5 h-5 inline" /> <FormattedMessage id="userMenu.logout" defaultMessage="Logout" /> 
                      </button>
                  </div>
                  : null
                  }
                </Dialog.Panel>
              </Transition.Child>
              
              <div className="w-14 flex-shrink-0">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
              
            </div>
          </Dialog>
          </Transition.Root>


          {/* SIGN IN MODAL */}
          <SignInModal isOpen={loginModalOpen} toggleModal={handleloginModalToggle} />
          
          {/* LANGUAGE MODAL */}
          <LanguageSelectModal isOpen={languageModalOpen} toggleModal={handleLanguageModalToggle} />
      
        </header>
    );
};

function mapStateToProps({ user, viewer }) {
	return { user, viewer }
}

export default connect(mapStateToProps)(HeaderMetedBase);